


































































































































































































import { Component, Mixins } from 'vue-property-decorator'
import { IMPORT_TYPES } from '@/classes/library'
import { Playlist } from '@/classes/playlist'
import { HistoryViewMixin, LibraryMixin } from '@/mixins'

enum VIEWS {
  Start = 'start', // Must be start
  SoftwareSelect = 'software_select',
  PlaylistSelect = 'playlist_select',
  DownloadRekordbox = 'download_rekordbox',
  DownloadTraktor = 'download_traktor',
  DownloadVirtualdj = 'download_virtualdj',
  DownloadSerato = 'download_serato',
  DownloadEngineprime = 'download_engineprime'
}

@Component({
  components: {
    PlaylistSelector: require('@/components/PlaylistSelector').default,
    HelpCircle: require('@/components/HelpCircle').default
  }
})
export default class ExportLibrary extends Mixins(HistoryViewMixin, LibraryMixin) {
  view: VIEWS = VIEWS.Start
  importType: IMPORT_TYPES
  loading: boolean = false
  selectedPlaylists: Playlist[] = []

  rekordboxOptionAddHotCues: boolean = false
  rekordboxOptionCopyToMemoryCues: boolean = false

  optionMapToNearestColor: boolean = true
  optionOnlyEditedTracks: boolean = false

  setImportType(v: IMPORT_TYPES) {
    this.importType = v

    if (this.importType === IMPORT_TYPES.Rekordbox) this.goToView(VIEWS.DownloadRekordbox)
    if (this.importType === IMPORT_TYPES.Traktor) this.goToView(VIEWS.DownloadTraktor)
    if (this.importType === IMPORT_TYPES.VirtualDJ) this.goToView(VIEWS.DownloadVirtualdj)
    if (this.importType === IMPORT_TYPES.Serato) this.goToView(VIEWS.DownloadSerato)
    if (this.importType === IMPORT_TYPES.EnginePrime) this.goToView(VIEWS.DownloadEngineprime)
  }

  async downloadRekordboxXml() {
    this.loading = true

    try {
      await this.$store.dispatch('library/download', {
        type: IMPORT_TYPES.Rekordbox,
        options: {
          addHotCues: this.rekordboxOptionAddHotCues,
          copyToMemoryCues: this.rekordboxOptionCopyToMemoryCues,
          mapToNearestColor: this.optionMapToNearestColor,
          onlyEditedTracks: this.optionOnlyEditedTracks,
          playlistIds: this.selectedPlaylists.map(p => p._id)
        }
      })
    } finally {
      this.loading = false
    }
  }

  async downloadTraktorNml() {
    this.loading = true

    try {
      await this.$store.dispatch('library/download', {
        type: IMPORT_TYPES.Traktor,
        options: {
          mapToNearestColor: this.optionMapToNearestColor,
          onlyEditedTracks: this.optionOnlyEditedTracks,
          playlistIds: this.selectedPlaylists.map(p => p._id)
        }
      })
    } finally {
      this.loading = false
    }
  }

  async downloadVirtualdjZip() {
    this.loading = true

    try {
      await this.$store.dispatch('library/download', {
        type: IMPORT_TYPES.VirtualDJ,
        options: {
          mapToNearestColor: this.optionMapToNearestColor,
          onlyEditedTracks: false,
          playlistIds: [],
          exportAsJson: false
        }
      })
    } finally {
      this.loading = false
    }
  }
}
